import { AppLayout } from '@/components/layout/AppLayout'
import { NotFoundPage, RouteErrorPage } from '@/components/layout/RouteFallbacks'
import { AccountPage } from '@/features/auth/AccountPage'
import { LoginPage, SetupPage } from '@/features/auth/AuthPages'
import { UsersPage } from '@/features/admin/UsersPage'
import { ImportPage } from '@/features/import/ImportPage'
import { IngredientsPage } from '@/features/ingredients/IngredientsPage'
import { RecommendationsPage } from '@/features/recommendations/RecommendationsPage'
import { RecipeDetailPage } from '@/features/recipes/RecipeDetailPage'
import { RecipeFormPage } from '@/features/recipes/RecipeFormPage'
import { RecipeListPage } from '@/features/recipes/RecipeListPage'
import { createBrowserRouter, redirect } from 'react-router-dom'

/**
 * Every screen is addressable. The sidebar links to a route root, so returning
 * to a section always lands on its list rather than on whatever was last open.
 */
export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
    errorElement: <RouteErrorPage />,
  },
  { path: '/setup', element: <SetupPage />, errorElement: <RouteErrorPage /> },
  {
    path: '/',
    element: <AppLayout />,
    errorElement: <RouteErrorPage />,
    children: [
      { index: true, loader: () => redirect('/recipes') },
      { path: 'recipes', element: <RecipeListPage /> },
      { path: 'recipes/new', element: <RecipeFormPage mode="create" /> },
      { path: 'recipes/import', element: <ImportPage /> },
      { path: 'recipes/:id', element: <RecipeDetailPage /> },
      { path: 'recipes/:id/edit', element: <RecipeFormPage mode="edit" /> },
      { path: 'ingredients', element: <IngredientsPage /> },
      { path: 'recommendations', element: <RecommendationsPage /> },
      { path: 'admin/users', element: <UsersPage /> },
      { path: 'account', element: <AccountPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
])